import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';

VCardModalController.$inject = [
  '$scope',
  '$timeout',
  '$uibModalInstance',
  'mode',
  'isSearch',
  'modalTitle',
  'saveText',
  'CardData',
  'AddressId',
  'CustomerDuplicatesData',
  'AddressService',
  'ModalData',
];

function VCardModalController(
  $scope: IScope & { vcardModal: TODO },
  $timeout: ITimeoutService,
  $uibModalInstance: UIBModal<TODO>,
  mode: string,
  isSearch: boolean,
  modalTitle: string,
  saveText: string,
  CardData: TODO,
  AddressId: TODO,
  CustomerDuplicatesData: TODO,
  AddressService: AddressService,
  ModalData: {
    isAutorenewMembership: boolean;
    membershipErrors: { missingPrimaryCardEmailForAutorenew: { message: string } };
    onMakePrimaryClick?(event: PointerEvent): void;
  }
) {
  const ctrl = {
    model: CardData || {},

    meta: CustomerDuplicatesData || null,

    mode: mode,

    modalData: ModalData,

    addresses: [] as TODO[],

    isSearch: false,

    title: modalTitle,
    saveText: saveText,
    footerText: '',

    init: function () {
      // if (this.checkAddress(this.model.address)) {
      //   this.addresses.push(angular.extend({}, AddressData, { id: AddressData.id ? AddressData.id : CardData.id || '' }));
      // }

      if (isSearch) {
        ctrl.isSearch = isSearch;
      }

      ctrl.addresses = AddressService.getAddresses(AddressId);

      if (ctrl.meta && ctrl.meta.match) {
        ctrl.footerText = 'Make sure the Customer info is accurate. Changes will take place on Checkout.';
      }

      $scope.$on('VcardCardholder::Complete', ctrl.done);
    },

    close: function () {
      $uibModalInstance.dismiss('cancel');
    },

    complete: function () {
      $scope.$broadcast('VcardCardholder::Process');
    },

    done: function () {
      $uibModalInstance.close({ contact: ctrl.model });
    },

    success: {
      init: function (response) {},
    },

    error: {
      init: function (response) {},
    },
  };

  $scope.vcardModal = ctrl;
  ctrl.init();
}

export const VCardModalControllerModule = angular
  .module('acme.view.application.modals.vcard.controllers', [AddressServiceModule])
  .controller('VcardModalController', VCardModalController).name;
